<template>
    <div class="ion-text-right">
        <ion-button
            @click="$emit('click')"
            class="ion-margin-top"
            fill="outline"
            :disabled="disabled"
            >Weiter</ion-button
        >
    </div>
</template>

<script>
import { IonButton } from "@ionic/vue";

export default {
    emits: ["click"],
    components: {
        IonButton,
    },
    props: {
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style></style>
